import Appsignal from "@appsignal/javascript";

export const appsignal = new Appsignal({
  key: `${process.env.REACT_APP_APPSIGNAL_KEY}`,
  revision: "baddb675acaa4562e4db6e96a4fe8bee94cee56e",
});
